/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemDependencySchema } from './itemDependencySchema';
import { projectedCustomFieldValueSchema } from './projectedCustomFieldValueSchema';
import { projectedEstimationSchema } from './projectedEstimationSchema';
import { projectedScheduleSchema } from './projectedScheduleSchema';

/**
 * @description A projected item. Only the requested fields are present, plus `id`.
 */
export const projectedItemResponseSchema = z
  .object({
    createdAt: z.iso.datetime().nullish(),
    createdBy: z.string().nullish(),
    customFieldValues: z
      .object({})
      .catchall(
        z.union([
          z.lazy(() => projectedCustomFieldValueSchema),
          z.array(
            z
              .lazy(() => projectedCustomFieldValueSchema)
              .describe('A custom field value, or an array of them for multi-value fields.'),
          ),
        ]),
      )
      .describe(
        'Custom field values keyed by field id, requested via the `customFields` token. Single-value fields hold one object, multi-value fields an array.',
      )
      .nullish(),
    deadlineDateTime: z.iso.datetime().nullish(),
    get dependencies() {
      return z.array(itemDependencySchema).nullish();
    },
    description: z.string().nullish(),
    doneDateTime: z.iso.datetime().nullish(),
    earliestStartDateTime: z.iso.datetime().nullish(),
    estimationId: z.int().nullish(),
    get estimationSchema() {
      return z.union([projectedEstimationSchema, z.null()]).optional();
    },
    externalCreatedAt: z.iso.datetime().nullish(),
    externalKey: z.string().nullish(),
    externalLink: z.string().nullish(),
    id: z.int(),
    itemStatusId: z.int().nullish(),
    itemTypeId: z.int().nullish(),
    loopId: z.int().nullish(),
    name: z.string().nullish(),
    parentId: z.int().nullish(),
    parentManagedByIntegration: z.boolean().nullish(),
    plannedFinishDateTime: z.iso.datetime().nullish(),
    plannedStartDateTime: z.iso.datetime().nullish(),
    priority: z.string().nullish(),
    get schedules() {
      return z.union([projectedScheduleSchema, z.null()]).optional();
    },
    schedulingType: z.enum(['ACTUALS_ONLY', 'PLANNED_AND_ACTUALS']).nullish(),
    teamId: z.int().nullish(),
    timeSpentSeconds: z.int().nullish(),
    updatedAt: z.iso.datetime().nullish(),
    updatedBy: z.string().nullish(),
  })
  .describe('A projected item. Only the requested fields are present, plus `id`.');
